import { navigate } from '@reach/router'
import { parse, stringify } from 'qs'

// utils
import deriveDefaultPayrollPeriod from 'utils/sef/deriveDefaultPayrollPeriod'

const pageFilterOptions = [
  'agreements',
  'oid',
  'outputAreaId',
  'outputSubAreaId',
  'partnerId',
  'payrollPeriod',
  'programName',
  'trackingPeriod',
  'worksiteId',
  'workspaceId'
]

const _getCookie = name => {
  const cookies = document.cookie.split('; ')

  for (var i = 0; i < cookies.length; i++) {
    var parts = cookies[i].split('=')
    if (parts[0] === name) {
      return parts.slice(1).join('=')
    }
  }

  return null
}

const _fetchSessionValues = () => {
  const values = []

  for (const opt of pageFilterOptions) {
    const optValue = _getCookie(opt)
    if (optValue) {
      values.push(`${opt}=${decodeURIComponent(optValue)}`)
    }
  }

  return values
}

const deriveFilterValue = ({ opts, param }) => {
  const sessionValues = _fetchSessionValues()

  const urlParams = parse(location.search.replace('?', ''))
  const paramsValue = urlParams[param]

  // search params in URL take top priority
  if (paramsValue) {
    return (
      opts.find(t => t.value === parseInt(paramsValue)) || opts.find(t => t.value === paramsValue)
    )
  }

  // check session cookie if no URL param
  const sessionValueString = sessionValues.find(s => s.match(`${param}=`))
  if (sessionValueString) {
    const sessionValue = sessionValueString.replace(`${param}=`, '')
    return (
      opts.find(t => t.value === parseInt(sessionValue)) || opts.find(t => t.value === sessionValue)
    )
  }

  // if user has single workspace, set value to their single value (for their convenience)
  if (param === 'workspaceId' && opts.length === 1) {
    return opts[0]
  }

  // return nothing
  return null
}

const injectSingleFilter = ({ value, valType }) => {
  // set temporary cookie to retain page filter options for current session
  if (value) {
    document.cookie = `${valType}=${value}; Path=/; SameSite=Lax`
  } else {
    document.cookie = `${valType}=; Path=/; SameSite=Lax`
  }
}

const updateSearchFilter = event => {
  const urlParams = parse(location.search.replace('?', ''))
  const newParams = stringify({ ...urlParams, s: event.target.value })
  const appendString = `?${newParams}`
  navigate(appendString, { replace: true })
}

const updateSearchFilterDropdown = ({ value, valType }) => {
  const valueAffectingPaging = value ? encodeURIComponent(value) : null
  const urlParams = parse(location.search.replace('?', ''))
  delete urlParams[valType]

  if (valueAffectingPaging) delete urlParams['page']
  if (valueAffectingPaging) urlParams[valType] = valueAffectingPaging

  injectSingleFilter({ value, valType })

  const appendString = `?${stringify(urlParams)}`
  navigate(appendString, { replace: true })
}

const updateParamFilter = ({ value, valType }) => {
  const valueAffectingPaging = value ? encodeURIComponent(value) : null
  const urlParams = parse(location.search.replace('?', ''))
  delete urlParams[valType]

  if (valueAffectingPaging) delete urlParams['page']
  if (valueAffectingPaging) urlParams[valType] = valueAffectingPaging

  injectSingleFilter({ value, valType })

  const appendString = `?${stringify(urlParams)}`
  navigate(appendString, { replace: true })
}

const injectSessionValuesIntoSearch = (injectOpts = {}) => {
  const { includePayroll, opts } = injectOpts

  const optsToInject = opts || pageFilterOptions

  for (const opt of optsToInject) {
    const urlParams = parse(location.search.replace('?', ''))
    const paramValue = urlParams[opt]
    const optValue = _getCookie(opt)

    if (paramValue) {
      updateSearchFilterDropdown({ value: paramValue, valType: opt })
    } else if (optValue) {
      updateSearchFilterDropdown({ value: optValue, valType: opt })
    }

    // set default payroll period to current if none has been set
    // so that payroll period is never undefined by default
    const isPayroll = opt === 'payrollPeriod'
    if (includePayroll && isPayroll && !optValue) {
      const defaultPayrollPeriod = deriveDefaultPayrollPeriod()
      updateSearchFilterDropdown({ value: defaultPayrollPeriod, valType: opt })
    }
  }
}

export default {
  deriveFilterValue,
  injectSessionValuesIntoSearch,
  updateSearchFilter,
  updateSearchFilterDropdown,
  updateParamFilter
}
export {
  deriveFilterValue,
  injectSessionValuesIntoSearch,
  updateSearchFilter,
  updateSearchFilterDropdown,
  updateParamFilter
}
